// extracted by mini-css-extract-plugin
export default {"timeSwitcherGroup":"range-switcher_timeSwitcherGroup__5t6Gz","timeSwitcher":"range-switcher_timeSwitcher__4ZULB","active":"range-switcher_active__TAlcZ"};